import { useQueryClient } from '@tanstack/react-query';
import { QueryKey } from '@/Config/api/queryKey';
import { AIAssistantsData, AIProfile, CurrentAIAssistant } from '@/Domain/components/TopBar/types';

export const useUpdateAssistantList = () => {
  const queryClient = useQueryClient();

  const updateAssistant = (scenarioId: string, update: Partial<AIProfile | CurrentAIAssistant>) =>
    queryClient.setQueryData([QueryKey.aiAssistants.get], (prevData: AIAssistantsData) => {
      const assistantList = prevData.all_ai_assistants.map((assistant) => {
        if (assistant.scenario_id === scenarioId) {
          return { ...assistant, ...update };
        }

        return assistant;
      });

      return {
        all_ai_assistants: assistantList,
        current_ai_assistant: {
          ...prevData.current_ai_assistant,
          ...update,
        },
      };
    });

  return { updateAssistant };
};
